import React, { useState } from 'react';
import api from '../services/api'; 
import { Link, useNavigate } from 'react-router-dom';
import '../styles/auth.css';
import etgLogo from '../assets/etg.png';
import ufmgLogo from '../assets/Ufmg-sem nome-03.png';

const Login = () => {
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();


  const handleCpfChange = (e) => {
    const { value } = e.target;
    setMessage('');
    const cleaned = value.replace(/\D/g, '');
    let formatted = '';
    if (cleaned.length > 0) {
      formatted = cleaned.substring(0, 3);
    }
    if (cleaned.length > 3) {
      formatted += '.' + cleaned.substring(3, 6);
    }
    if (cleaned.length > 6) {
      formatted += '.' + cleaned.substring(6, 9);
    }
    if (cleaned.length > 9) {
      formatted += '-' + cleaned.substring(9, 11);
    }

    setCpf(formatted);
  };

  const handleLogin = async () => {
    try {
      const response = await api.post('/auth/login', { cpf, senha });
      if (response.data.success) {
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/');
      } else {
        const errorMessage = response.data.error || 'CPF/senha incorretos.';
        setMessage(errorMessage);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'CPF/senha incorretos.';
      setMessage(errorMessage);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <div className="title-container">
          <img src={etgLogo} alt="ETG Logo" className="logo" />
          <h2>Login</h2>
          <img src={ufmgLogo} alt="UFMG Logo" className="logo" />
        </div>
        <div className="form-group">
          <input
            type="text"
            placeholder="CPF"
            value={cpf}
            onChange={handleCpfChange}
            maxLength="14"
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>
        <button onClick={handleLogin}>
          Entrar
        </button>
        <div className="login-link">
          <span>Não tem uma conta? </span>
          <Link to="/register">Registre-se</Link>
        </div>
        <div className="login-link">
          <Link to="/forgot-password">Esqueceu a senha?</Link>
        </div>
        <div className="login-link">
          <a href="https://bimescolar.org" target="_blank" rel="noopener noreferrer">Informações do Projeto BimEscolar</a>
        </div>
        {message && <p className="auth-message" style={{ color: message.includes('sucesso') ? 'green' : 'red' }}>{message}</p>}
      </div>
    </div>
  );
};

export default Login;
